// removed by extract-text-webpack-plugin
module.exports = {"with-ellipsis":"RoomsCancellationPolicy_with-ellipsis---sb","withEllipsis":"RoomsCancellationPolicy_with-ellipsis---sb","rooms-cancellation-policy":"RoomsCancellationPolicy_rooms-cancellation-policy---sb","roomsCancellationPolicy":"RoomsCancellationPolicy_rooms-cancellation-policy---sb","rtl":"RoomsCancellationPolicy_rtl---sb","row":"RoomsCancellationPolicy_row---sb","title":"RoomsCancellationPolicy_title---sb","text":"RoomsCancellationPolicy_text---sb"};


//////////////////
// WEBPACK FOOTER
// ./src/components/RoomsCancellationPolicy/styles.less
// module id = 1656
// module chunks = 0